
import { Vue } from "vue-property-decorator";
import { apiUrl, assetsUrl } from "@/env";
import { ISequence } from "@/schemas/ISequence";
import { authHeader, corsHeaders, jsonHeaders } from "@/repository/deps";

export default Vue.extend({
  data: () => ({
    cards: [
      {
        title: "Module 1",
        image: "module_1_btn.png",
        duration: 7,
        key_word: "compétences collaboratives, activités d'entrainement...",
        iframe: "https://view.genially.com/67287660596984caccd6d244",
        pdf: "Module 1 - Pourquoi vouloir entraîner les personnes à travailler en équipe.pdf",
        flex: 6,
        id: "383e5200-39c1-46f8-b9a0-06334e388508",
      },
      {
        title: "Module 2",
        image: "module_2_btn.png",
        duration: 8,
        key_word: "interpréter les résultats, calcul des scores, synergie...",
        iframe: "https://view.genially.com/691c3e371aed878b23a68adb",
        pdf: "Module 2 - Pourquoi utiliser la plateforme numérique ECC'IPE _.pdf",
        flex: 6,
        id: "a29d7c57-e743-4977-b8fb-49d4b9c529a3",
      },
      {
        title: "Module 3",
        image: "module_3_btn.png",
        duration: 8,
        key_word:
          "répartition de la parole, gestion du conflit, mode de prise de décision...",
        iframe: "https://view.genially.com/676188b556df681a22255c67/",
        pdf: "module_3.pdf",
        flex: 6,
        id: "2239d2a9-7937-4615-81f3-fac9d7225b8c",
      },
      // { title: 'Comment faire un débriefing ?',
      //   duration: 5,
      //   key_word:'étapes du débriefing, feedback de performance et de participation...',
      //   iframe: 'src1',
      //   pdf: 'pdf1',
      //   flex: 6,
      // },
    ],
    anim: false,
    nbr_consult: -1,
    iframe_url: "",
  }),

  methods: {
    consulter(index): void {
      console.log("consulter", index);
      this.anim = !this.anim;
      this.nbr_consult = index;
      console.log("consulter", this.cards[index].iframe);
      this.iframe_url = this.cards[index].iframe;
      console.log(this.cards[index].id);
      this.count(this.cards[index].id, "consultation");
    },
    download(index): void {
      this.count(this.cards[index].id, "download");
    },

    count(moduleId: string, type: string): void {
      this.$store.dispatch("moduleConsultationAdd", {
        moduleId: moduleId,
        type: type,
        next: (response) => {
          console.log(response);
        },
      });
    },

    retour(): void {
      this.anim = !this.anim;
    },

    generate_pdf_url(index): void {
      console.log("generate_pdf_url", index);
      return `${assetsUrl}guides/${this.cards[index].pdf}`;
    },

    hasLink(card: any): boolean {
      if (card.iframe == "src1") {
        return false;
      } else {
        return true;
      }
    },

    getImageSrc(slug: string): string {
      return `${assetsUrl}guides/${slug}`;
    },
  },
});
